import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import { withHighlightedHeadline } from "~/components/content/content-item-render/hoc";
import { useContentItemProviders } from "~/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { homeSuperSplashLiveSecondaryContentItemContent$key } from "~/queries/__generated__/homeSuperSplashLiveSecondaryContentItemContent.graphql";

import {
  ActionBar,
  Container,
  Content,
  Headline,
  HeadlineContainer,
  StyledEntityLink,
} from "./styles";

export type Props = {
  reference: homeSuperSplashLiveSecondaryContentItemContent$key;
  withComment?: boolean;
} & ContentItemRenderVariantProps;

const Component = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, reference: reference_, withComment = false }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeSuperSplashLiveSecondaryContentItemContent on Content {
          entityId
          ...entityLink
          ...hooksContentItemProvidersContent
            @arguments(withHeadline: true, withLiveTag: true, withActionBar: true)
        }
      `,
      reference_,
    );
    const providers = useContentItemProviders(content);

    return (
      <Container className={className} ref={reference}>
        <Content>
          <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
            <HeadlineContainer>
              <Headline>
                {providers.headline({
                  hideTooltip: true,
                  preferSocialHeadline: true,
                  skipHighlight: true,
                })}
              </Headline>
              {providers.liveTag()}
            </HeadlineContainer>
          </StyledEntityLink>
          <ActionBar>
            {providers.actionBar({
              commentVariant: "reverse",
              isBookmarkVisible: false,
              isCommentsVisible: withComment ?? false,
            })}
          </ActionBar>
        </Content>
      </Container>
    );
  },
);

Component.displayName = "ContentItemHomeSuperSplashLiveSecondary";

export const ContentItemHomeSuperSplashLiveSecondary = withHighlightedHeadline(Component);
